'use strict';

// turbolinks:load でイベントをバインドし、turbolinks:before-cache でクリーンアップする

$(document).on('turbolinks:load', function() {
  var dataEl = document.getElementById('team-edit-member-data');
  if (!dataEl) return;

  var data = JSON.parse(dataEl.dataset.config);
  var icons = JSON.parse(dataEl.dataset.icons || '{}');
  var i18n = JSON.parse(dataEl.dataset.i18n || '{}');
  var teamColor = data.teamColor;
  var minContrastRatio = data.minContrastRatio;
  var initialMembers = data.members;
  var playerNameMaxLength = data.playerNameMaxLength;
  var maxLeaguePlayers = data.maxLeaguePlayers;
  var isPro = data.isPro;
  var playedPlayers = data.playedPlayers || [];
  var authenticatedUsers = data.authenticatedUsers || [];
  var authenticationUrl = data.authenticationUrl || '';
  var checkAuthenticatedUsersUrl = data.checkAuthenticatedUsersUrl || '';
  var isGuest = data.isGuest || false;

  var currentLeaguePlayerCount = data.currentLeaguePlayerCount;
  var $page = $('.team-ui-page');
  var members = initialMembers.slice();
  var removeTargetId = null;
  var newPlayerSeq = 1000;
  var newPlayerIds = new Set();
  var playedPickSelectedIds = [];
  var playedSortMode = 'recent';

  // 初期カラー設定
  $page[0].style.setProperty('--team-color', teamColor);

  // ===== カラー設定 =====
  function setTeamColor(hex) {
    var sufficient = window.TeamColorContrast.isSufficient(hex);
    var warnEl = document.getElementById('contrastWarn');
    if (warnEl) warnEl.classList.toggle('show', !sufficient);
    if (!sufficient) return;

    $page[0].style.setProperty('--team-color', hex);
    var hexDisplay = document.getElementById('hexDisplay');
    if (hexDisplay) hexDisplay.textContent = hex.toUpperCase();
    var customColor = document.getElementById('customColor');
    if (customColor) customColor.value = hex;
    updatePreview();
    markDirty();
  }

  $(document).on('change.teamEdit input.teamEdit', '#customColor', function() {
    setTeamColor($(this).val());
  });

  // ===== ライブプレビュー =====
  function updatePreview() {
    var nameVal = $('#teamName').val() || i18n.teamNameUnset;
    $('#previewName').text(nameVal);
    if (!$('#logoSelected').hasClass('show')) {
      $('#previewInitial').text(nameVal.charAt(0) || '？');
    }

    var descVal = $('#teamDesc').val() || '';
    var $previewDesc = $('#previewDesc');
    $previewDesc.text(descVal);
    $previewDesc.toggle(descVal.length > 0);
  }

  // 文字数カウンターは components/form_counter.js が更新する
  $(document).on('input.teamEdit', '#teamName', function() {
    updatePreview();
    markDirty();
  });

  $(document).on('input.teamEdit', '#teamDesc', function() {
    updatePreview();
    markDirty();
  });

  // ===== ロゴ =====
  if (isPro) {
    $(document).on('click.teamEdit', '#logoDrop', function() {
      $('#logoInput').click();
    });
    $(document).on('keydown.teamEdit', '#logoDrop', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $('#logoInput').click();
      }
    });

    $(document).on('change.teamEdit', '#logoInput', function() {
      var file = this.files[0];
      if (!file) return;
      var MAX_SIZE = 2 * 1024 * 1024;
      var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        TeamUiShared.showToast(i18n.toastInvalidImageFormat, 'warn');
        $(this).val('');
        return;
      }
      if (file.size > MAX_SIZE) {
        TeamUiShared.showToast(i18n.toastImageTooLarge, 'warn');
        $(this).val('');
        return;
      }
      $('#remove_logo_field').val('0');
      var reader = new FileReader();
      reader.onload = function(e) {
        $('#logoSelectedImg').attr('src', e.target.result);
        $('#logoSelected').addClass('show');
        $('#logoDrop').hide();
        $('#previewLogo').html('<img src="' + e.target.result + '" alt="' + i18n.teamLogoAlt + '">');
        markDirty();
      };
      reader.readAsDataURL(file);
    });

    $(document).on('click.teamEdit', '#logoRemove', function() {
      $('#logoSelected').removeClass('show');
      $('#logoDrop').show();
      $('#logoInput').val('');
      $('#remove_logo_field').val('1');
      var nameVal = $('#teamName').val() || '？';
      $('#previewLogo').html('<span id="previewInitial">' + JanrecoUtils.escapeHtml(nameVal.charAt(0)) + '</span>');
      markDirty();
    });
  }

  // ===== メンバー描画 =====
  function renderMembers() {
    var $list = $('#memberList');
    $list.empty();
    members.forEach(function(m) {
      var $row = $('<div>', { class: 'member-row', 'data-player-id': m.id });
      if (!newPlayerIds.has(m.id)) {
        $row.append($('<input>', { type: 'hidden', name: 'member_ids[]', value: m.id }));
      }
      $row.append($('<div>', { class: 'member-avatar' }).text(m.name.charAt(0)));
      $row.append($('<span>', { class: 'member-name' }).text(m.name));
      if (m.isSelf) {
        var $selfTag = $('<span>', { class: 'member-tag' });
        $selfTag.append($('<span>').text(i18n.tagYou));
        $row.append($selfTag);
      } else if (m.hasMatches) {
        var $tag = $('<span>', { class: 'member-tag' });
        $tag.append($(icons.lock));
        $tag.append($('<span>').text(i18n.tagHasMatchRecord));
        $row.append($tag);
      } else {
        var $btn = $('<button>', {
          type: 'button',
          class: 'member-remove',
          'data-id': m.id,
          'aria-label': i18n.removeFromTeamAria.replace('%{name}', m.name)
        });
        $btn.append($(icons.remove));
        $row.append($btn);
      }
      $list.append($row);
    });
    updateMemberCount();
  }

  function updateMemberCount() {
    var count = members.length;
    $('#memberCount').text(count);
    $('#previewMemberCount').text(count);
  }

  // ===== メンバー除外 =====
  $(document).on('click.teamEdit', '#memberList .member-remove', function() {
    var pid = parseInt($(this).data('id'), 10);
    var member = members.find(function(m) { return m.id === pid; });
    if (!member) return;
    if (member.isSelf) return;

    if (newPlayerIds.has(pid)) {
      members = members.filter(function(m) { return m.id !== pid; });
      $('input[name="new_player_names[]"][data-temp-id="' + pid + '"]').remove();
      $('input[name="add_to_league_player_ids[]"][data-temp-id="' + pid + '"]').remove();
      renderMembers();
      markDirty();
      return;
    }

    removeTargetId = pid;
    $('#removeTargetName').text(member.name);
    TeamUiShared.openSheet('removeSheetOverlay');
  });

  $(document).on('click.teamEdit', '#removeConfirmBtn', function() {
    if (removeTargetId === null) return;
    var member = members.find(function(m) { return m.id === removeTargetId; });
    if (!member) { TeamUiShared.closeSheet('removeSheetOverlay'); return; }

    var $form = $('#team-form');

    // セッション内で追加したプレイヤーを除外する場合は、追加用hiddenも取り消す
    var $addedInput = $form.find('input[name="add_to_league_player_ids[]"][data-add-pid="' + removeTargetId + '"]');
    if ($addedInput.length > 0) {
      // このセッションで追加したばかりのプレイヤーなので、追加inputを削除するだけでよい
      $addedInput.remove();
      currentLeaguePlayerCount--;
    } else {
      // 元からチームにいるメンバーなので、除外リクエストを送信する
      $form.append($('<input>', { type: 'hidden', name: 'remove_player_ids[]', value: removeTargetId, class: 'js-hidden-submit' }));
      // 保存時に実際のリーグ人数が1人減るため、フロントの人数カウンタも減算しておく
      currentLeaguePlayerCount--;
    }

    members = members.filter(function(m) { return m.id !== removeTargetId; });
    renderMembers();
    TeamUiShared.closeSheet('removeSheetOverlay');
    markDirty();
    TeamUiShared.showToast(i18n.toastRemovedFromTeam.replace('%{name}', member.name));
    removeTargetId = null;
  });

  // ===== タブ切り替え =====
  var addTabs = [
    { tab: 'addTabName', panel: 'addPanelName' },
    { tab: 'addTabPlayed', panel: 'addPanelPlayed' },
    { tab: 'addTabInvite', panel: 'addPanelInvite' }
  ];

  function activateAddTab(activeTabId) {
    addTabs.forEach(function(t) {
      var tabEl = document.getElementById(t.tab);
      var panelEl = document.getElementById(t.panel);
      if (!tabEl || !panelEl) return;
      var isActive = t.tab === activeTabId;
      tabEl.classList.toggle('is-active', isActive);
      tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) { panelEl.removeAttribute('hidden'); }
      else { panelEl.setAttribute('hidden', ''); }
    });
  }

  addTabs.forEach(function(t) {
    $(document).on('click.teamEdit', '#' + t.tab, function() {
      activateAddTab(t.tab);
      if (t.tab === 'addTabName') { $('#newPlayerName').focus(); }
      // 「過去の対戦相手」タブに切り替えたら候補リストをリセット・再描画
      if (t.tab === 'addTabPlayed') { resetAndRenderPlayedPick(); }
    });
  });

  // ===== メンバー追加シート（名前で追加タブ） =====
  $(document).on('input.teamEdit', '#newPlayerName', function() {
    var val = $.trim($(this).val());
    $('#newPlayerAdd').prop('disabled', val.length === 0);
  });

  $(document).on('click.teamEdit', '#newPlayerAdd', function() {
    var nameVal = $.trim($('#newPlayerName').val());
    if (!nameVal) return;
    if (nameVal.length > playerNameMaxLength) {
      TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastPlayerNameMaxlen, playerNameMaxLength), 'warn');
      return;
    }
    if (currentLeaguePlayerCount >= maxLeaguePlayers) {
      TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastPlayerLimit, maxLeaguePlayers), 'warn');
      return;
    }
    var tempId = ++newPlayerSeq;
    newPlayerIds.add(tempId);
    members.push({ id: tempId, name: nameVal, hasMatches: false });
    var $form = $('#team-form');
    $form.append($('<input>', { type: 'hidden', name: 'new_player_names[]', value: nameVal, class: 'js-hidden-submit', 'data-temp-id': tempId }));
    currentLeaguePlayerCount++;
    $('#newPlayerName').val('');
    $('#newPlayerAdd').prop('disabled', true);
    renderMembers();
    markDirty();
    TeamUiShared.showToast(i18n.toastAdded.replace('%{name}', nameVal));
  });

  $(document).on('keydown.teamEdit', '#newPlayerName', function(e) {
    if (e.key === 'Enter') {
      var oe = e.originalEvent;
      if (oe && (oe.isComposing || oe.keyCode === 229)) return;
      e.preventDefault();
      $('#newPlayerAdd').click();
    }
  });

  // ===== 過去の対戦相手タブ =====
  if (playedPlayers.length === 0) {
    var playedTab = document.getElementById('addTabPlayed');
    if (playedTab) playedTab.setAttribute('hidden', '');
  }

  function renderPlayedPick() {
    var list = document.getElementById('playedPickList');
    if (!list) return;
    list.innerHTML = '';

    var memberIds = members.map(function(m) { return m.id; });
    var available = playedPlayers.filter(function(p) {
      return memberIds.indexOf(p.id) === -1;
    });

    if (playedSortMode === 'name') {
      available.sort(function(a, b) { return a.name.localeCompare(b.name, 'ja'); });
    }

    if (available.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'empty-candidates-note';
      empty.textContent = i18n.noAddablePlayers;
      list.appendChild(empty);
      return;
    }

    available.forEach(function(p) {
      var isSelected = playedPickSelectedIds.indexOf(p.id) !== -1;
      var row = document.createElement('div');
      row.className = 'candidate-row' + (isSelected ? ' selected' : '');
      row.dataset.pid = p.id;
      var check = document.createElement('span');
      check.className = 'candidate-check';
      check.innerHTML = icons.check;
      row.appendChild(check);
      var name = document.createElement('span');
      name.className = 'candidate-name';
      name.textContent = p.name;
      row.appendChild(name);
      list.appendChild(row);
    });
  }

  // タブ切り替え時に選択・並び順をリセットしてから描画
  function resetAndRenderPlayedPick() {
    playedPickSelectedIds = [];
    playedSortMode = 'recent';
    renderPlayedPick();
    updatePlayedPickBtn();
    $('#playedSortRecent').addClass('is-active');
    $('#playedSortName').removeClass('is-active');
  }

  $(document).on('click.teamEdit', '#playedPickList .candidate-row', function() {
    var pid = parseInt($(this).data('pid'), 10);
    var idx = playedPickSelectedIds.indexOf(pid);
    if (idx !== -1) { playedPickSelectedIds.splice(idx, 1); }
    else { playedPickSelectedIds.push(pid); }
    renderPlayedPick();
    updatePlayedPickBtn();
  });

  function updatePlayedPickBtn() {
    var n = playedPickSelectedIds.length;
    var btn = document.getElementById('playedPickConfirm');
    if (btn) {
      btn.disabled = n === 0;
      btn.textContent = window.Janreco.pluralize(i18n.addCount, n);
    }
  }

  $(document).on('click.teamEdit', '#playedPickConfirm', function() {
    if (playedPickSelectedIds.length === 0) return;
    var $form = $('#team-form');
    var addedCount = 0;
    var limitReached = false;
    playedPickSelectedIds.forEach(function(pid) {
      if (currentLeaguePlayerCount >= maxLeaguePlayers) { limitReached = true; return; }
      var p = playedPlayers.find(function(pl) { return pl.id === pid; });
      if (!p) return;
      members.push({ id: p.id, name: p.name, hasMatches: false });
      // data-add-pid を付けることで、このセッションで追加したプレイヤーを後から特定できる
      $form.append($('<input>', { type: 'hidden', name: 'add_to_league_player_ids[]', value: p.id, class: 'js-hidden-submit', 'data-add-pid': p.id }));
      currentLeaguePlayerCount++;
      addedCount++;
    });
    if (addedCount > 0) {
      renderMembers();
      markDirty();
      TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastAddedToTeam, addedCount));
    }
    if (limitReached) {
      TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastPlayerLimit, maxLeaguePlayers), 'warn');
    }
    playedPickSelectedIds = [];
    renderPlayedPick();
    updatePlayedPickBtn();
  });

  $(document).on('click.teamEdit', '#playedSortRecent', function() {
    playedSortMode = 'recent';
    $(this).addClass('is-active');
    $('#playedSortName').removeClass('is-active');
    renderPlayedPick();
  });

  $(document).on('click.teamEdit', '#playedSortName', function() {
    playedSortMode = 'name';
    $(this).addClass('is-active');
    $('#playedSortRecent').removeClass('is-active');
    renderPlayedPick();
  });

  // ===== 招待タブ =====
  if (authenticationUrl) {
    var urlEl = document.getElementById('inviteUrl');
    if (urlEl) urlEl.textContent = authenticationUrl;

    var qrEl = document.getElementById('inviteQr');
    if (qrEl) {
      $.ajax({
        url: '/qr_codes',
        method: 'GET',
        data: { url: authenticationUrl },
        success: function(data) {
          qrEl.innerHTML = data.qr_code;
        },
        error: function() {
          console.error('QRコード生成に失敗しました');
        }
      });
    }
  }

  if (isGuest) {
    var inviteTab = document.getElementById('addTabInvite');
    if (inviteTab) inviteTab.setAttribute('hidden', '');
  }

  $(document).on('click.teamEdit', '#inviteCopy', function() {
    if (!authenticationUrl) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(authenticationUrl).then(function() {
        TeamUiShared.showToast(i18n.toastInviteCopied);
      }).catch(function() {
        TeamUiShared.showToast(i18n.toastCopyFailed, 'warn');
      });
    } else {
      TeamUiShared.showToast(i18n.toastCopyFailed, 'warn');
    }
  });

  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
  }

  $(document).on('click.teamEdit', '#inviteCheck', function() {
    var btn = this;
    if (btn.disabled) return;
    btn.disabled = true;

    fetch(checkAuthenticatedUsersUrl, {
      method: 'GET',
      headers: { 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() },
      credentials: 'same-origin'
    })
    .then(function(res) { return res.json(); })
    .then(function(players) {
      if (!players || players.length === 0) {
        TeamUiShared.showToast(i18n.toastNoNewAuthenticated);
        return;
      }
      var memberIds = members.map(function(m) { return m.id; });
      var added = 0;
      var limitReached = false;
      var $form = $('#team-form');
      players.forEach(function(p) {
        if (memberIds.indexOf(p.id) !== -1) return;
        if (currentLeaguePlayerCount >= maxLeaguePlayers) { limitReached = true; return; }
        members.push({ id: p.id, name: p.name, hasMatches: false });
        // data-add-pid を付けることで、このセッションで追加したプレイヤーを後から特定できる
        $form.append($('<input>', { type: 'hidden', name: 'add_to_league_player_ids[]', value: p.id, class: 'js-hidden-submit', 'data-add-pid': p.id }));
        currentLeaguePlayerCount++;
        added++;
      });
      if (added > 0) {
        renderMembers();
        markDirty();
        TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastAuthenticatedAdded, added));
      } else if (!limitReached) {
        TeamUiShared.showToast(i18n.toastNoNewAuthenticated, 'warn');
      }
      if (limitReached) {
        TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastPlayerLimit, maxLeaguePlayers), 'warn');
      }
    })
    .catch(function(e) {
      console.error('認証確認に失敗:', e);
      TeamUiShared.showToast(i18n.toastAuthCheckFailed, 'warn');
    })
    .finally(function() {
      btn.disabled = false;
    });
  });

  // ===== メンバー追加シートを開く =====
  $(document).on('click.teamEdit', '#addMemberBtn', function() {
    activateAddTab('addTabName');
    $('#newPlayerName').val('');
    $('#newPlayerAdd').prop('disabled', true);
    TeamUiShared.openSheet('addSheetOverlay');
    setTimeout(function() { $('#newPlayerName').focus(); }, 100);
  });

  // ===== チーム削除シート =====
  $(document).on('click.teamEdit', '#deleteTeamBtn', function() {
    var teamName = $('#teamName').val() || i18n.teamFallback;
    $('#deleteTargetName').text(teamName);
    TeamUiShared.openSheet('deleteSheetOverlay');
  });

  // ===== 保存バー =====
  function markDirty() {
    $('#saveBar').addClass('show');
  }

  $(document).on('click.teamEdit', '#saveBtnTrigger', function() {
    $('#team-form').submit();
  });

  // ===== 初期描画 =====
  renderMembers();
  updatePreview();
  var hexDisplay = document.getElementById('hexDisplay');
  if (hexDisplay) hexDisplay.textContent = teamColor.toUpperCase();
});

// Turbolinksページ離脱前に委譲ハンドラと動的hiddenを一括解除する
document.addEventListener('turbolinks:before-cache', function() {
  // .teamEdit 名前空間の委譲ハンドラを全解除する（Turbolinks再訪問時の多重登録を防ぐ）
  $(document).off('.teamEdit');
  // 動的に追加したhidden inputをキャッシュスナップショットから除去する
  $('#team-form .js-hidden-submit').remove();
  // シートとトーストの表示状態をリセットする
  ['addSheetOverlay', 'removeSheetOverlay', 'deleteSheetOverlay'].forEach(function(id) {
    TeamUiShared.closeSheet(id);
  });
  $('#toast').removeClass('show');
});
